{
  "nl": {
    "timestamp": {
      "labels": {
        "accepted": "Aanvaard op {date}",
        "ago": "geleden",
        "daysAgo": "{days} dag |{days} dagen",
        "daysRemaining": "{days} resterende dagen",
        "due": "Deadline: {date}",
        "dueToday": "Vandaag",
        "expired": "Verlopen op {date}",
        "hoursAgo": "{hours} uur | {hours} uur",
        "in": "Binnen {time}",
        "justNow": "Zonet",
        "minutesAgo": "{minutes} minuut | {minutes} minuten",
        "monthsAgo": "{months} maand | {months} maanden",
        "noDeadline": "Geen deadline",
        "overdue": "Te laat met {days} dagen",
        "sentOn": "Verzonden op {date}",
        "sentOnAt": "Verzonden op {date} om {time}",
        "starts": "Start: {date}",
        "today": "Vandaag",
        "tomorrow": "Morgen",
        "uploaded": "Geüpload op {date}",
        "weeksAgo": "{weeks} week | {weeks} weken",
        "yearsAgo": "{years} jaar | {years} jaar",
        "yesterday": "Gisteren"
      }
    }
  }
}
